import { combineReducers } from 'redux';

import extras from './extras';
import proactiveWorks from './proactiveWorks';
import questions from './questions';
import selectedTab from './selectedTab';
import status from './status';

/**
 * @typedef {{
 *  status: StatisticsSelfServiceDetailsReducer,
 * }} StatisticsSelfServiceDetailsReducer
 */

export default combineReducers({
  status,
  questions,
  extras,
  selectedTab,
  proactiveWorks,
});
